<template>
  <div>
    <h2 style="margin-bottom: 16px;">{{ id ? '编辑' : '创建' }}信息</h2>
    <el-form ref="form" :model="form" label-width="80px" style="max-width: 720px;">
      <el-form-item label="标题">
        <el-input v-model="form.help_title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="分类">
        <el-radio-group v-model="form.help_lable">
          <el-radio v-for="item in lable" :key="item" :label="item">{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="标签">
        <el-tag v-for="tag in dynamicTags" :key="tag" closable :disable-transitions="false" @close="handleClose(tag)" style="margin-right: 8px;">{{ tag }}</el-tag>
        <el-input
          v-if="inputVisible"
          v-model="inputValue"
          size="small"
          style="width: 100px;"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        ></el-input>
        <el-button v-else size="small" @click="showInput">+ 新标签</el-button>
      </el-form-item>
      <el-form-item label="内容">
        <rich-editor v-model="form.help_content"></rich-editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">确定</el-button>
        <el-button @click="$router.push('/admin/createhelplist')">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import richEditor from '@/components/editor.vue'
import { getLable, createHelp, updateHelp, getHelpDetails } from '@/api'

export default {
  name: 'CreateHelp',
  components: { richEditor },
  props: { id: { type: String, default: '' } },
  data() {
    return {
      lable: [],
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      form: { help_tag: '', help_title: '', help_lable: '', help_content: '' }
    }
  },
  created() {
    getLable('问答分类').then((res) => {
      this.lable = JSON.parse(res.data[0].lable) || []
    })
    if (this.id) this.getdetails()
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {})
    },
    handleInputConfirm() {
      if (this.inputValue) this.dynamicTags.push(this.inputValue)
      this.inputVisible = false
      this.inputValue = ''
    },
    getdetails() {
      getHelpDetails(this.id).then((res) => {
        const d = res.data || {}
        this.form.help_title = d.help_title
        this.form.help_lable = d.help_lable
        this.form.help_content = d.help_content
        this.dynamicTags = (d.help_tag || '').split(',')
      })
    },
    onSubmit() {
      if (!this.form.help_title || !this.form.help_lable) {
        this.$message.error('请填写标题和分类')
        return
      }
      this.form.help_tag = String(this.dynamicTags)
      if (this.id) {
        updateHelp({ ...this.form, id: this.id }).then((res) => {
          if (res.state.type === 'SUCCESS') {
            this.$message.success('修改成功')
            this.$router.push('/admin/createhelplist')
          }
        })
      } else {
        createHelp(this.form).then((res) => {
          if (res.state.type === 'SUCCESS') {
            this.$message.success('发布成功，等待审核')
            this.$router.push('/admin/createhelplist')
          }
        })
      }
    }
  }
}
</script>
